// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"PageCheckersDashboard__pageWrap__1L1sg"};